import { Chain } from '@web3/utils';
import { ChainTypes } from './wallet-hub/core/types';

/** 钱包类型 */
export enum WalletTypesString {
  /** 云钱包，托管钱包 */
  CLOUD = 'CLOUD',
  /** mpc钱包 */
  MPC = 'MPC',
  /** AA钱包 */
  AA = 'AA',
  /** 私钥钱包 */
  PRIVATE_KEY = 'PRIVATE_KEY',
  /** 助记词钱包 */
  MNEMONIC_PHRASE = 'MNEMONIC_PHRASE',
  /** 观察者钱包 */
  FOLLOW_ADDRESS = 'FOLLOW_ADDRESS',
  /** metamask钱包或其他三方钱包 */
  THIRD_PARTY = 'THIRD_PARTY',
}

export enum WalletTypesNumber {
  NOT = 0,
  /** 云钱包，托管钱包 */
  CLOUD = 1,
  /** mpc钱包 */
  MPC = 2,
  /** AA钱包 */
  AA = 3,
  /** 私钥钱包 */
  PRIVATE_KEY = 4,
  /** 助记词钱包 */
  MNEMONIC_PHRASE = 5,
  /** 观察者钱包 */
  FOLLOW_ADDRESS = 6,
  /** metamask钱包或其他三方钱包 */
  THIRD_PARTY = 7,
}

export type WalletData = {
  /** 钱包类型 */
  walletType: WalletTypesString;
  /** 钱包名称 */
  walletName: string;
  /** 钱包头像 */
  walletPicUrl: string;
  /** 资产折u */
  amountUsd: string;
  /** 钱包id mpc和观察钱包有，修改钱包名称时传回 */
  walletId: string;
  /** 链钱包地址 */
  addressChain: WalletAddressChain[];
  /** 支持的功能，app使用 */
  walletBizType: string;
};

/** 链钱包信息 */
export type WalletAddressChain = {
  /** 钱包地址 */
  address: string;
  /** 链Code */
  chainCode: string;
  /** 链ID */
  chainId: string;
  /** 公钥 */
  custodyPubKey: string;
  chainType: ChainTypes;
};

/**
 * 启用状态  1-未开始 2-进行中 3-已结束
 */
export enum activityStatusEnum {
  /** 未开始 */
  unStart = 1,
  /** 进行中 */
  processing = 2,
  /** 已结束 */
  end = 3,
}
export type StakingTask = {
  /** 任务配置ID */
  configId: number;
  /** 任务开始时间 */
  startTime: number;
  /** 任务结束时间 */
  endTime: number;
  /** 活动状态 */
  activityStatus: activityStatusEnum;
};

/** 账户信息 */

export type MemberInfo = {
  memberId: string;
  avatar: {
    avatarId: string;
    avatarUrl: string;
  };
  switchMember: number;
  rsa: number;
  subUtaOpen: number;
  subMember2faVerify: number;
  source: string;
  isDemo: boolean;
  isKycwallWhite: boolean;
  agree: boolean;
  siteId: string;
  isAff: boolean;
  isHideCopyTradeApi: boolean;
  copytradeUpgrade: string;
  copytradeNick: string;
  copytradePhoto: string;
  memberType: number;
  isExistsSubmember: boolean;
};

export type Ticker = {
  s: string;
  c: string;
};

/** 币信息 */
export type TokenItem = {
  chainId: string;
  chainCode: string;
  chainName: string;
  price: string;
  decimals: number;
  contract: string;
  iconDayUrl: string;
  iconNightUrl: string;
  type: number;
  balance: string;
  balanceUsd: string;
  symbol: string;
};

export type TokenItemWithChain = TokenItem & {
  chain?: Chain;
};

/** 三方充值信息 */
export type ThirdDepositInfo = {
  apex: {
    canWithdraw: 1 | 2;
    minAmt: string;
  };
  bybit: {
    canWithdraw: 1 | 2;
    minAmt: string;
  };
};

/**
 * 链余额模型
 */
export type WalletChainBalance = {
  chainId: string;
  chainCode: string;
  chainType: ChainTypes;
  address: string;
  amountUsd: string;
  tokenAsset: Array<TokenItem>;
};

/**
 * 钱包余额模型
 */
export type WalletBalance = {
  totalAmountUsd: string;
  addressAsset: Array<WalletChainBalance>;
};

/** 用户合规信息 */
export type UserRegulationDTO = {
  regulationCountry: string;
  userSiteId: string;
  referSiteId: string;
};
